import React, { useState, useEffect } from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import ProblemSolution from './components/ProblemSolution';
import Features from './components/Features';
import CallToAction from './components/CallToAction';
import Footer from './components/Footer';
import LegalPage from './components/LegalPage';

function App() {
  const [currentPath, setCurrentPath] = useState(window.location.pathname);

  useEffect(() => {
    const handlePopState = () => setCurrentPath(window.location.pathname);
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  if (currentPath === '/privacy' || window.location.hash === '#privacy') {
    return <LegalPage type="privacy" />;
  }

  if (currentPath === '/terms' || window.location.hash === '#terms') {
    return <LegalPage type="terms" />;
  }

  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <ProblemSolution />
        <Features />
        <CallToAction />
      </main>
      <Footer />
    </div>
  );
}

export default App;
